import { Reducer, createSlice } from "@reduxjs/toolkit";
import { AppDispatch } from "../state";
import { SERVER_URL } from "../../utils/server";
import { Callback } from "../../index.d";
import { toggleSessionExpired } from "../utils/uiSlice";
import { pageSizeReq } from "../../utils/constants";

export type Utilisateur = {
  [index: string]: any;
  dateCreation?: string;
  dateModification?: string;
  telephone: string;
  nom: string;
  prenom?: string;
  adresse?: string;
  latitude?: number;
  longitude?: number;
  actif?: boolean;
  email?: string;
  roleUtilisateur?: any;
};

export declare interface UtilisateurState {
  [index: string]: any;
}
const initialState: UtilisateurState = {};

export const utilisateurSlice = createSlice({
  initialState,
  name: "utilisateur",
  reducers: {
    createUtilisateur: (state, action) => {
      state[action.payload.id] = action.payload;
      return state;
    },
    listUtilisateur: (state, action) => {
      for (const obj of action.payload) {
        state[obj.id] = obj;
      }
      return state;
    },
    removeUtilisateur: (state, action) => {
      delete state[action.payload];
      return state;
    },
    updateUtilisateur: (state, action) => {
      state[action.payload.id] = {
        ...state[action.payload.id],
        ...action.payload,
      };
      return state;
    },
  },
});

export const {
  createUtilisateur,
  listUtilisateur,
  removeUtilisateur,
  updateUtilisateur,
} = utilisateurSlice.actions;

export const createAsyncUtilisateur =
  (data: Utilisateur, callback: Callback, onError: Callback) =>
  async (dispatch: AppDispatch, getState: any) => {
    try {
      const user = getState().auth.user;
      const result = await fetch(`${SERVER_URL}utilisateur`, {
        method: "POST",
        body: JSON.stringify(data),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${user?.token}`,
        },
      });

      if (result.status === 403) {
        dispatch(toggleSessionExpired({ payload: true }));
        return;
      }

      if ([201,200].includes(result.status)) {
        dispatch(listAsyncUtilisateur());
        callback?.();
      } else {
        onError?.();
      }
    } catch (error) {
      console.log("create utilisateur error", error);
      onError?.();
    }
  };

export const createAsyncAdminUtilisateur =
  (data: Utilisateur, callback: Callback, onError: Callback) =>
  async (dispatch: AppDispatch, getState: any) => {
    try {
      const user = getState().auth.user;
      const result = await fetch(`${SERVER_URL}utilisateur/admin-all/add`, {
        method: "POST",
        body: JSON.stringify(data),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${user?.token}`,
        },
      });

      if (result.status === 403) {
        dispatch(toggleSessionExpired({ payload: true }));
        return;
      }

      if ([201,200].includes(result.status)) {
        dispatch(listAsyncUtilisateur());
        callback?.();
      } else {
        onError?.();
      }
    } catch (error) {
      console.log("create utilisateur error", error);
      onError?.();
    }
  };

export const updateAsyncAdminUtilisateur =
  (data: Utilisateur, callback: Callback, onError: Callback) =>
  async (dispatch: AppDispatch, getState: any) => {
    try {
      const user = getState().auth.user;
      const result = await fetch(`${SERVER_URL}utilisateur/admin-all/update/${data.id}`, {
        method: "PUT",
        body: JSON.stringify(data),
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${user?.token}`,
        },
      });

      if (result.status === 403) {
        dispatch(toggleSessionExpired({ payload: true }));
        return;
      }

      if ([201,200].includes(result.status)) {
        dispatch(listAsyncUtilisateur());
        callback?.();
      } else {
        onError?.();
      }
    } catch (error) {
      console.log("update utilisateur error", error);
      onError?.();
    }
  };

export const deleteAsyncAdminUtilisateur =
  (data: Utilisateur, callback: Callback, onError: Callback) =>
  async (dispatch: AppDispatch, getState: any) => {
    try {
      const user = getState().auth.user;
      const result = await fetch(`${SERVER_URL}utilisateur/${data.id}`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${user?.token}`,
        },
      });

      if (result.status === 403) {
        dispatch(toggleSessionExpired({ payload: true }));
        return;
      }

      if ([201,200].includes(result.status)) {
        dispatch(removeUtilisateur(data.id));
        callback?.();
      } else {
        onError?.();
      }
    } catch (error) {
      console.log("delete utilisateur error", error);
      onError?.();
    }
  };

export const listAsyncUtilisateur =
  () => async (dispatch: AppDispatch, getState: any) => {
    try {
      const user = getState().auth.user;

      const result = await fetch(
        `${SERVER_URL}utilisateur/admin-all?size=${pageSizeReq}&page=1`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${user?.token}`,
          },
        }
      );

      if (result.status === 403) {
        dispatch(toggleSessionExpired({ payload: true }));
        return;
      }

      const res = await result.json();
      if (res.data.length) {
        dispatch(listUtilisateur(res.data));
      }
    } catch (error) {
      console.log("list utilisateur error", error);
      // onError?.();
    }
  };

export default utilisateurSlice.reducer as Reducer<UtilisateurState>;
